export const contactsData = {
    email: 'info@marita.dev',
    address: 'Florida, United States',

    sheetAPI: ''
}